import { Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import { CircularProgress, Tooltip, Select, MenuItem, FormControl, InputAdornment, TextField, Button, TableContainer, Table, TableHead, TableBody, Paper, TablePagination, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box, FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { post } from '../../../services/http';
import { ContextSession } from "../../../services/ContextSession";
import FilterListIcon from '@mui/icons-material/FilterList';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import PropTypes from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

async function getSolicitudes(accesos, ip) {
    let json = { data: "null" };
    let url = "https://be.injupemp.gob.hn:8443/api/resumen/";
    //let url = "http://172.20.7.10:8082/api/resumen/"; //IP PRUEBAS
    let auto = "Bearer " + accesos;

    let datas = await post(url, json, auto);
    // console.log("LA DATA DE LA TABLA ES: ", datas);
    return datas;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#19438C',
        color: 'white',
        fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        borderRight: 'none', // Elimina la línea vertical entre columnas
        borderLeft: 'none', // Elimina la línea vertical entre columnas
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    '&:hover': { // Agrega estilo al pasar el cursor sobre la fila
        backgroundColor: '#C1C1C1', // Cambia el color de fondo al pasar el cursor
    },
}));

// CSS para los botones de acción
const actionButtonsCSS = `
    .action-buttons {
        display: flex;
        gap: 20px;
    }

    .action-buttons a:hover {
        opacity: 0.7; //Cambia la opacidad al pasar el cursor 
        cursor: pointer;  Cambia el cursor al pasar sobre los botones 
    }
`;

function ConfirmationDialogRaw(props) {
    const { onClose, value: valueProp, open, options, ...other } = props;
    const [value, setValue] = useState(valueProp);
    const radioGroupRef = React.useRef(null);

    useEffect(() => {
        if (!open) {
            setValue(valueProp);
            setValue(null); // Resetear el valor del RadioGroup al cerrar el diálogo
        }
    }, [valueProp, open]);


    const handleEntering = () => {
        if (radioGroupRef.current != null) {
            radioGroupRef.current.focus();
        }
    };

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onClose(value);
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };
}

ConfirmationDialogRaw.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
};

const fetchUsers = async (ip) => {
    try {
        const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/auth/oficiales`, {
            method: 'GET', // Cambia el método a POST
            headers: {
                'Content-Type': 'application/json', // Define el tipo de contenido si es necesario
                // 'Authorization': `Bearer ${tuToken}`, // Si necesitas autenticar la solicitud
            },
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error al obtener usuarios:', error);
        return [];
    }
};


function AsignarSolicitudes() {
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogUser, setDialogUser] = useState(null); // Estado para controlar el usuario seleccionado en el Dialog
    const [error, setError] = useState('');

    useEffect(() => {
        fetchUsers(sessi.ip).then((data) => setUsers(data));
    }, []);

    const handleConfirmDialogOpen = () => {
        setOpenConfirmDialog(true);
    };

    const handleConfirmDialogClose = (confirm) => {
        setOpenConfirmDialog(false);
        if (confirm) {
            handleConfirmAssign();
        }
    };


    const handleOpenDialog = (solicitudID) => {
        setSelectedSolicitudID(solicitudID); // Guardar el ID de la solicitud seleccionada
        setOpenDialog(true);
    };


    const handleDialogClose = () => {
        if (!dialogUser) {
            setError('Debe seleccionar un usuario.');
            return;
        }
        setOpenDialog(false);
        const selected = users.find(user => user.id === parseInt(dialogUser, 10));
        setSelectedUser(selected);
        setOpenConfirmDialog(true); // Abrir el diálogo de confirmación
    };


    const [isAssigning, setIsAssigning] = useState(false); // Nuevo estado para controlar el CircularProgress
    const [successDialogOpen, setSuccessDialogOpen] = useState(false); // Nuevo estado para el mensaje de éxito

    const handleConfirmAssign = async () => {
        if (selectedUser && selectedSolicitudID) {
            setLoading(true); // Mostrar el CircularProgress
            try {
                await patchAssignUser(selectedSolicitudID, selectedUser.id, sessi.ip);
                console.log('Asignación realizada con éxito');

                // Volver a cargar los datos de la tabla
                const token = sessi.sessionData.token;
                const updatedData = await getSolicitudes(token, sessi.ip);

                const sortedData = updatedData.sort((a, b) => {
                    if (a.asignado === null && b.asignado !== null) return -1;
                    if (a.asignado !== null && b.asignado === null) return 1;
                    return new Date(a.FechaSolicitud) - new Date(b.FechaSolicitud);
                });

                setFilas(sortedData); // Actualizar la tabla
                setSuccessDialogOpen(true); // Mostrar el mensaje de éxito
            } catch (error) {
                console.error('Error al asignar la solicitud:', error);
            } finally {
                setLoading(false); // Ocultar el CircularProgress
            }
            setOpenDialog(false);
            setSelectedUser(null);
            setSelectedSolicitudID(null);
        } else {
            console.error('No se ha seleccionado un usuario o una solicitud.');
        }
    };


    let sessi = useContext(ContextSession);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const [loanType, setLoanType] = useState('');
    const [statusFilter, setStatusFilter] = useState('Sin Asignar');
    const [filas, setFilas] = useState([]);

    useEffect(() => {
        async function fetchData() {
            let token = sessi.sessionData.token;
            const data = await getSolicitudes(token, sessi.ip);
            // Ordenar las filas
            const sortedData = data.sort((a, b) => {
                // Primero, ordenar por estado
                if (a.asignado === null && b.asignado !== null) {
                    return -1; // 'Sin Asignar' debe ir antes que 'Asignado'
                }
                if (a.asignado !== null && b.asignado === null) {
                    return 1;
                }
                // Luego, ordenar por fecha de solicitud (más antigua primero)
                return new Date(a.FechaSolicitud) - new Date(b.FechaSolicitud);
            });
            setFilas(sortedData);
            setLoading(false);
        }
        fetchData();
    }, [sessi.sessionData.token, sessi.ip]);


    useEffect(() => {
        async function fetchData() {
            try {
                let token = sessi.sessionData.token;
                const response = await getSolicitudes(token, sessi.ip);
                if (response.ok) {
                    const data = await response.json();
                    setFilas(data);
                } else {
                    console.error('Error al obtener datos:', response.status, response.statusText);
                }
                setLoading(false);
            } catch (error) {
                console.error('Error al obtener datos:', error);
            }
        }
        fetchData();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/Participante/Solicitudes');
    };

    const handleClickCarga = (id) => {
        sessi.setVariable("SolicitudPrestamo", id);
        navigate(`/Participante/SolicitudesCarga`);
    };

    const handleSearchChange = (event) => {
        const searchTerm = event.target.value.toLowerCase();
        setSearchTerm(searchTerm);
    };

    const handleLoanTypeChange = (event) => {
        setLoanType(event.target.value);
    };

    const handleStatusChange = (event) => {
        setStatusFilter(event.target.value);
    };

    const [selectedTable, setSelectedTable] = useState('Asignado');

    const handleTableChange = (event) => {
        setSelectedTable(event.target.value);
    };

    const filteredRows = filas.filter((row) => {
        const status = row.asignado !== null ? 'Asignado' : 'Sin Asignar';

        return (
            (row.TipoPrestamo?.includes(loanType) || loanType === '') &&
            (status.includes(statusFilter) || statusFilter === '') &&
            (
                searchTerm === '' ||
                (searchTerm && (
                    row.NumeroSolicitud?.toString().includes(searchTerm) ||
                    (row.solicitante && row.solicitante[0] && (row.solicitante[0].Nombres?.toLowerCase().includes(searchTerm) || row.solicitante[0].Apellidos?.toLowerCase().includes(searchTerm)))
                ))
            )
        );
    });

    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const [filterType, setFilterType] = useState('');

    const handleFilterClick = (event, type) => {
        setAnchorEl(event.currentTarget);
        setFilterType(type);
    };

    const handleFilterClose = () => {
        setAnchorEl(null);
        setFilterType('');
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [selectedSolicitudID, setSelectedSolicitudID] = useState(null);

    const patchAssignUser = async (idAsignacion, idOficial, ip) => {
        // console.log("ID SOLICITUD ES: ", idAsignacion, "ID DEL OFICIAL ES: ", idOficial);
        const url = `https://be.injupemp.gob.hn:8443/api/asignarOficial/`;
        //const url = `http://172.20.7.10:8082/api/asignarOficial/`; //IP PRUEBAS
        const formData = new FormData();
        formData.append('idAsignacion', idAsignacion);
        formData.append('idOficial', idOficial);

        try {
            const response = await fetch(url, {
                method: 'PATCH',
                body: formData,
            });

            if (response.ok) {
                console.log('Asignación realizada con éxito');
            } else {
                console.error('Error al realizar la asignación:', response.status, response.statusText);
            }
        } catch (error) {
            console.error('Error en la solicitud:', error);
        }
    };


    return (
        <div className="container" style={{ marginTop: 10 }}>
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    <Dialog
                        open={openDialog}
                        onClose={() => setOpenDialog(false)}
                        sx={{
                            '& .MuiDialog-paper': {
                                width: '80%', // Ajusta el ancho del diálogo
                                maxWidth: 'none', // Evita que el diálogo tenga un ancho máximo predeterminado
                            },
                        }}
                    >
                        <DialogTitle textAlign={'center'}>Seleccionar Usuario</DialogTitle>
                        <DialogContent
                            dividers
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                maxHeight: '400px', // Limita la altura del contenedor
                                overflowY: 'auto', // Habilita el scroll vertical
                                overflowX: 'hidden', // Evita el scroll horizontal
                            }}
                        >
                            <RadioGroup
                                aria-label="users"
                                name="users"
                                value={dialogUser}
                                onChange={(event) => {
                                    setDialogUser(event.target.value);
                                    setError(''); // Limpiar el mensaje de error al seleccionar un usuario
                                }}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start', // Alinea los elementos al inicio del contenedor
                                    width: '100%', // Ocupa todo el ancho disponible
                                }}
                            >
                                {users.map((user) => (
                                    <FormControlLabel
                                        value={user.id.toString()}
                                        key={user.id}
                                        control={<Radio color="error" variant="solid" />}
                                        label={user.nombre}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center', // Alinea el radio y el texto verticalmente
                                        }}
                                    />
                                ))}
                            </RadioGroup>
                            {error && (
                                <Typography color="error" variant="body2">
                                    {error}
                                </Typography>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => setOpenDialog(false)}
                                variant="contained"
                                sx={{
                                    backgroundColor: '#AD8401',
                                    color: 'black',
                                    marginRight: 1,
                                    '&:hover': {
                                        backgroundColor: '#8c8c8c',
                                        color: 'white',
                                    },
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={handleDialogClose}
                                variant="contained"
                                sx={{
                                    backgroundColor: '#AD8401',
                                    color: 'black',
                                    '&:hover': {
                                        backgroundColor: '#8c8c8c',
                                        color: 'white',
                                    },
                                }}
                            >
                                Asignar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={successDialogOpen}
                        onClose={() => setSuccessDialogOpen(false)}
                        aria-labelledby="success-dialog-title"
                        aria-describedby="success-dialog-description"
                    >
                        <DialogTitle id="success-dialog-title">
                            <Box display="flex" alignItems="center">
                                <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
                                {"Solicitud Asignada con Éxito"}
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="success-dialog-description">
                                La solicitud ha sido asignada correctamente al usuario seleccionado.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => setSuccessDialogOpen(false)}
                                variant="contained"
                                sx={{
                                    backgroundColor: '#19438C',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: '#5AA9B0',
                                    },
                                }}
                            >
                                Cerrar
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <Dialog open={openConfirmDialog} onClose={() => handleConfirmDialogClose(false)}>
                        <DialogTitle>Confirmar Asignación</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                ¿Está seguro de asignar la solicitud al usuario {selectedUser ? selectedUser.nombre : ''}?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleConfirmDialogClose(false)} variant="contained"
                                sx={{
                                    backgroundColor: '#AD8401',
                                    color: 'black',
                                    '&:hover': {
                                        backgroundColor: '#8c8c8c',
                                        color: 'white',
                                    },
                                }}>
                                No
                            </Button>
                            <Button onClick={() => handleConfirmDialogClose(true)} variant="contained"
                                sx={{
                                    backgroundColor: '#AD8401',
                                    color: 'black',
                                    '&:hover': {
                                        backgroundColor: '#8c8c8c',
                                        color: 'white',
                                    },
                                }}>
                                Sí
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                        <h2><b>Asignar Solicitudes</b></h2>
                    </div>

                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column" // Alinea el contenido verticalmente en el centro
                    >
                        <FormControl>
                            <FormHelperText style={{ textAlign: 'center' }}>Filtrar por estado:</FormHelperText>

                            <Select
                                value={statusFilter}
                                onChange={handleStatusChange}
                                style={{ marginBottom: '20px', marginTop: '5px', minWidth: '100px' }}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                <MenuItem value="Asignado">Asignado</MenuItem>
                                <MenuItem value="Sin Asignar">Sin Asignar</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <div className="row" style={{ marginTop: '20px' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell style={{ textAlign: 'center' }}>#</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <strong>No. Solicitud</strong>
                                                <Tooltip title="Buscar por Solicitud" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                                                        <ManageSearchIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <strong>Nombre del Solicitante</strong>
                                                <Tooltip title="Buscar por Nombre" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                                                        <ManageSearchIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <strong>Tipo De Préstamo</strong>
                                                <Tooltip title="Filtrar por Tipo" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'loanType')}>
                                                        <FilterListIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <strong>Fecha Solicitud</strong>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <strong>Etapa</strong>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <strong>Estado</strong>
                                                <Tooltip title="Filtrar por Estado" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'status')}>
                                                        <FilterListIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <strong>Acciones</strong>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>

                                <Popover
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleFilterClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                >
                                    {filterType === 'search' && (
                                        <TextField
                                            placeholder="Realizar Búsqueda"
                                            aria-label="Search"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}
                                    {filterType === 'loanType' && (
                                        <FormControl>
                                            <Select
                                                value={loanType}
                                                onChange={handleLoanTypeChange}
                                                displayEmpty
                                            >
                                                <MenuItem value=""><em>Todos los tipos</em></MenuItem>
                                                <MenuItem value="Sin Aval">Sin Aval</MenuItem>
                                                <MenuItem value="Con Aval">Con Aval</MenuItem>
                                                <MenuItem value="Consolidacion de Deuda">Consolidacion de Deuda</MenuItem>
                                                <MenuItem value="Alivio de Deuda">Alivio de Deuda</MenuItem>
                                                <MenuItem value="Refinanciamiento">Refinanciamiento</MenuItem>
                                                <MenuItem value="Hipotecario">Hipotecario</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                    {filterType === 'status' && (
                                        <FormControl>
                                            <Select
                                                value={statusFilter}
                                                onChange={handleStatusChange}
                                                displayEmpty
                                            >
                                                <MenuItem value=""><em>Todos</em></MenuItem>
                                                <MenuItem value="Sin Asignar">Sin Asignar</MenuItem>
                                                <MenuItem value="Asignado">Asignado</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                </Popover>
                                <TableBody>
                                    {filteredRows.length > 0 ? (
                                        (rowsPerPage > 0
                                            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            : filteredRows
                                        ).map((row) => (
                                            <StyledTableRow key={row.SolicitudID}>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.SolicitudID !== null && row.SolicitudID !== undefined && row.SolicitudID}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.NumeroSolicitud !== null && row.NumeroSolicitud !== undefined && row.NumeroSolicitud}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.solicitante && row.solicitante[0] && row.solicitante[0].Nombres && row.solicitante[0].Apellidos && `${row.solicitante[0].Nombres} ${row.solicitante[0].Apellidos}`}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.TipoPrestamo !== null && row.TipoPrestamo !== undefined && row.TipoPrestamo}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.FechaSolicitud !== null && row.FechaSolicitud !== undefined && row.FechaSolicitud.slice(0, 10)}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.aprobado === 4 ? 'Solicitud Formal' : 'Preanálisis'}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.asignado !== null ? 'Asignado' : 'Sin Asignar'}
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                    <div className="action-buttons" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <button
                                                            onClick={() => handleOpenDialog(row.SolicitudID)}
                                                            title="Asignar Usuario"
                                                            style={{
                                                                color: 'grey',
                                                                margin: '0 1px',
                                                                background: 'none',
                                                                border: 'none',
                                                                cursor: row.asignado === null ? 'pointer' : 'not-allowed', // Cambiar el cursor
                                                                opacity: row.asignado === null ? 1 : 0.5, // Cambiar la opacidad
                                                            }}
                                                            disabled={row.asignado !== null} // Deshabilitar el botón
                                                        >
                                                            <i className="material-icons">group_add</i>
                                                        </button>
                                                    </div>
                                                </StyledTableCell>

                                            </StyledTableRow>
                                        ))
                                    ) : (
                                        <StyledTableRow>
                                            <StyledTableCell colSpan={8} style={{ textAlign: 'center' }}>
                                                No se encontraron datos
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {filteredRows.length > 0 && (
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={filteredRows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                labelRowsPerPage={"Filas por página"}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default AsignarSolicitudes;